import useSWR from 'swr'
import { requestGet } from '../utils/services'

const useUserProgrammes = (userId?: any) => {
  const userProgrammesKey = userId
    ? `/users/${userId}?populate[programmes][populate][programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][filters][user][id][$eq]=${userId}&populate[programmes][populate][programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][user]=*&populate[programmes][populate][programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][sub_module]=*&populate[programmes][populate][programme_types][populate][sub_modules][populate][sections][populate][sub_module][populate][sub_module_submissions][populate][section][populate]=*`
    : null

  const { data, mutate, isValidating } = useSWR(
    userProgrammesKey,
    (url: string) => requestGet(url),
    { revalidateOnFocus: false }
  )

  if (data) {
    const programmesData = data?.programmes || []
    const userProgrammes = programmesData.map((programme: any) => {
      const rawProgramme = programme
      const programmeTypes = (
        rawProgramme?.programme_types?.data ||
        rawProgramme?.programme_types ||
        []
      ).map((pt: any) => {
        const rawPt = pt
        return {
          id: pt.id,
          ...rawPt,
          submodules: (rawPt?.sub_modules?.data || rawPt?.sub_modules || []).map((sm: any) => {
            const rawSm = sm
            return {
              id: sm.id,
              ...rawSm,
              sections: (rawSm?.sections?.data || rawSm?.sections || []).map((sec: any) => {
                const rawSec = sec
                return {
                  id: sec.id,
                  ...rawSec,
                  sub_module: sec.sub_module || rawSec?.sub_module
                }
              })
            }
          })
        }
      })
      return {
        id: programme.id,
        ...rawProgramme,
        programmeTypes
      }
    })

    return {
      userProgrammes,
      updateProgrammes: () => mutate(),
      isValidating: isValidating
    }
  }
  return {
    userProgrammes: undefined,
    updateProgrammes: () => mutate(),
    isValidating: !data
  }
}

export default useUserProgrammes
